import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Lef-Nav" }
const _hoisted_2 = { class: "App-Lef-Nav-W" }
const _hoisted_3 = { class: "App-Lef-Nav-W-M" }
const _hoisted_4 = { class: "App-Lef-Nav-W-S" }
const _hoisted_5 = { style: {"padding":"15px 10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_logo = _resolveComponent("app-logo")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_app_account_top = _resolveComponent("app-account-top")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_space, {
        direction: "vertical",
        size: 60,
        alignment: "center",
        "w-100": "",
        fill: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_logo, { size: 30 }),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_menu, { router: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "users" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "el-icon-user" }, null, -1),
                      _createElementVNode("span", null, "Users", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "startups" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "el-icon-office-building" }, null, -1),
                      _createElementVNode("span", null, "Startups", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "opportunities" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "el-icon-s-opportunity" }, null, -1),
                      _createElementVNode("span", null, "Opportunities", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "biddings" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "el-icon-document" }, null, -1),
                      _createElementVNode("span", null, "Bids", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "transactions" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "el-icon-document" }, null, -1),
                      _createElementVNode("span", null, "Transactions", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_menu_item, { index: "invitations" }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("i", { class: "el-icon-check" }, null, -1),
                      _createElementVNode("span", null, "Invitations", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createVNode(_component_app_account_top, { user: _ctx.user }, null, 8, ["user"]),
                false
                  ? (_openBlock(), _createBlock(_component_el_menu, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, { index: "3" }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("span", null, "Account", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, { index: "3" }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("span", null, "Logout", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_app_footer, { "txt-center": "" })
    ])
  ]))
}